import { render, staticRenderFns } from "./WorkflowOpen.vue?vue&type=template&id=0178f17c&scoped=true&"
import script from "./WorkflowOpen.vue?vue&type=script&lang=ts&"
export * from "./WorkflowOpen.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowOpen.vue?vue&type=style&index=0&id=0178f17c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0178f17c",
  null
  
)

export default component.exports